import { Feature } from 'ol';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style.js';

export const positionMarkerStyle = (feature) => {
    if (!feature || !(feature instanceof Feature)) {
        return new Error('style: invalid feature type');
    }
    feature.setStyle(new Style({
        image: new CircleStyle({
            radius: 6,
            fill: new Fill({
                color: '#3399CC'
            }),
            stroke: new Stroke({
                color: '#fff',
                width: 2
            })
        })
    }));
};

export default positionMarkerStyle;
